import {instance} from "./axiosInstance";


export const AuthAPI = {
    login: async (username, password) => {
        let response = await instance.post('/token/obtain/', {username, password})
        instance.defaults.headers['Authorization'] = "JWT " + response.data.access;
        localStorage.setItem('access_token', response.data.access);
        localStorage.setItem('refresh_token', response.data.refresh);
        return response;
    },
    logout: async () => {
        return await instance.post('/token/blacklist/', {
            "refresh_token": localStorage.getItem("refresh_token")
        });
    }
}


export const MasterOfActsAPI = {
    getProjects: (contract) => {
        return instance.get(`master-of-acts/projects/?contract=${contract}`)
    },
    createProject: (name) => {
        return instance.post('master-of-acts/projects/', {name})
    },

    getContracts: () => instance.get('master-of-acts/contracts/'),

    getCompaniesChart: (startTime = null, endTime = null, company = null,) => {
        return instance.get(`master-of-acts/kpi/?start_time=${startTime}&end_time=${endTime}&company=${company}`)},

    getCompaniesChartDeepAnalytics: (name, startTime, endTime, localCompany, contractorName, interval,) => {
        return instance.get(`master-of-acts/kpi/${name}/?start_time=${startTime}&end_time=${endTime}&local_company=${localCompany}&contractor_name=${contractorName}&interval=${interval}`)},    

    getContractorActs: (organization = null) => {
        return instance.get(`master-of-acts/contractors/?organization=${organization}`)},
    
    getContractorViolations: (organization = null, actID = null) => {
        return instance.get(`master-of-acts/contractors/${actID}/?organization=${organization}`)},
    
    putContractorViolations: (organization = null, actID = null, data) => {
        return instance.put(`master-of-acts/contractors/${actID}/?organization=${organization}`, data)},

    getContractorRemovalFiles: (fileId) => {
        return instance.get(`master-of-acts/removal-files/${fileId}/`)},

    getContractorViolationFiles: (fileId) => {
        return instance.get(`master-of-acts/violation-files/${fileId}/`)},

    createContracts: ({name, company}) => instance.post('master-of-acts/contracts/', {name, company}),

    getCompanies: () => instance.get('master-of-acts/companies/'),

    getEnvironmentStates: (contract = null, project = null, wordTemplate = null, actTemplate = null, isActive = null) => {
        let url = 'master-of-acts/environment-state/?'

        if (contract) {
            url += `contract=${contract}&`
        }
        if (project) {
            url += `project=${project}&`
        }
        if (wordTemplate) {
            url += `word_template=${wordTemplate}&`
        }
        if (actTemplate) {
            url += `act_template=${actTemplate}&`
        }
        if (isActive) {
            url += `is_active=${isActive}&`
        }
        return instance.get(url.slice(0, -1))
    },

    getEnvironmentState: (id) => {
        return instance.get(`master-of-acts/environment-state/${id}/`)
    },

    getActTemplate: (id) => {
        return instance.get(`/master-of-acts/act-templates/${id}/`)
    },

    getCurrentActTemplate: (projectId) => {
        return instance.get(`/master-of-acts/get-act-template-version/${projectId}/`)
    },

    updateActTemplate: (id, data) => {
        return instance.put(`/master-of-acts/act-templates/${id}/`, data)
    },

    getFieldTemplates: (actTemplate) => {
        return instance.get(`bulk/field-templates/?act_template=${actTemplate}`)
    },

    createFieldTemplate: (data) => {
        return instance.post('master-of-acts/field-templates/', data)
    },

    createFieldTemplates: (data) => {
        return instance.post('bulk/field-templates/', data)
    },

    getHandbooks: (project) => {
        return instance.get(`master-of-acts/handbooks/?project=${project}`)
    },

    getHandbook: id => {
        return instance.get(`master-of-acts/handbooks/${id}/`)
    },

    createHandbook: (name, project) => {
        return instance.post('master-of-acts/handbooks/', {name, project})
    },

    uploadViolationAttachment: (name, type, handbook, creator, file) => {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('name', name)
        formData.append('filename', name)
        formData.append('type', type)
        formData.append('handbook', handbook)
        formData.append('creator', creator)
        return instance.post(`master-of-acts/violation-files/`, formData)
    },

    uploadContractorRemovalFiles: (name, type, creator, file, violation) => {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('name', name)
        formData.append('filename', name)
        formData.append('creator', creator)
        formData.append('type', type)
        formData.append('violation', violation) // act
        return instance.post(`master-of-acts/removal-files/`, formData)
    },

    deleteContractorRemovalFile: (id) => {
        return instance.delete(`master-of-acts/removal-files/${id}/`)
    },

    downloadContractorRemovalFile: (fileId) => {
        return instance.get(`files/get-removal-files/${fileId}/`, {responseType: 'blob'})
    },

    uploadActScan: (creator, file, filename) => {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('creator', creator)
        formData.append('filename', filename)
        return instance.post(`master-of-acts/act-files/`, formData)
    },

    getActScan: (id) => instance.get(`master-of-acts/act-files/${id}/`),

    deleteViolationAttachment: (id) => {
        return instance.delete(`master-of-acts/violation-files/${id}/`)
    },

    getViolation: id => instance.get(`master-of-acts/violations/${id}/`),

    patchViolation: (id, data) => instance.patch(`master-of-acts/violations/${id}/`, data),

    addViolation: (name, content, rawContent, environmentState, creator, normativeArticles, files) => {
        return instance.post('master-of-acts/violations/', {
            name,
            content,
            raw_content: rawContent,
            environment_state: environmentState,
            normative_articles: normativeArticles,
            creator,
            files
        })
    },

    deleteViolation: (id) => {
        return instance.delete(`master-of-acts/violations/${id}/`)
    },

    getNormativeArticles: (normativeDocuments, searchString, page, deleted = false) => {
        let url = `master-of-acts/normative-articles/?normative_document=${normativeDocuments.join(',')}&deleted=${deleted}&search=${searchString}`
        if (page) {
            url += `&page=${page}`
        }
        return instance.get(url)
    },

    getNormativeArticle: (id, fields = null) => {
        return instance.get(`master-of-acts/normative-articles/${id}/${fields ? '?fields=' + fields.join(',') : null}`)
    },

    createAct: ({name, content, rawContent, status, comments, files, environment_state, creator, field_contractor, violations}) => {
        return instance.post('master-of-acts/acts/', {
            name,
            content,
            raw_content: rawContent,
            status,
            environment_state,
            creator,
            field_contractor,
            files,
            comments,
            violations
        })
    },

    createActLock: ({name, content, rawContent, status, comments, files, environment_state, creator, violations}) => {
        return instance.post('master-of-acts/act-lock/', {
            name,
            content,
            raw_content: rawContent,
            status,
            environment_state,
            creator,
            files,
            comments,
            violations
        })
    },

    saveAct: (id, {name, content, rawContent, status, comments, files, environment_state, creator, field_contractor, violations}) => {
        return instance.patch(`master-of-acts/acts/${id}/`, {
            name,
            content,
            raw_content: rawContent,
            status,
            environment_state,
            comments,
            files,
            creator,
            field_contractor,
            violations
        })
    },

    saveActLock: (id, {name, content, rawContent, status, comments, files, environment_state, creator, violations}) => {
        return instance.put(`master-of-acts/act-lock/${id}/`, {
            name,
            content,
            raw_content: rawContent,
            status,
            environment_state,
            comments,
            files,
            creator,
            violations
        })
    },

    getActs: (environmentState = null, project = null) => {
        let url = 'master-of-acts/acts/?'
        if (environmentState) {
            url += `environment_state=${environmentState}&`
        }
        if (project) {
            url += `environment_state__project=${project}&`
        }
        return instance.get(url.slice(0, -1))
    },

    getActsInfinite: (environmentState = null, project = null, formData) => {
        let url = 'master-of-acts/acts/?'
        if (environmentState) {
            url += `environment_state=${environmentState}&`
        }
        if (project) {
            url += `environment_state__project=${project}&`
        }
        return instance.get(url.slice(0, -1), formData)
    },

    getAct: id => instance.get(`master-of-acts/acts/${id}/`),

    getActForViolation: id => instance.get(`master-of-acts/act-for-violation/${id}/`),

    deleteAct: (id) => {
        return instance.delete(`master-of-acts/acts/${id}/`)
    },

    getTableTemplate: (project) => {
        return instance.get(`master-of-acts/table-templates/?project=${project}`)
    },

    changeTableTemplate: (id, data) => {
        return instance.put(`master-of-acts/table-templates/${id}/`, data)
    },
    downloadExcelReport: (project) => {

        
        return instance.get(`/generate-report-excel/${project}`, {responseType: 'blob'})
    },
    downloadAnalysisFile: () => {
        return instance.get(`/analysis-file/`, {responseType: 'blob'})
    },
    downloadActFileDoc: (actId) => {
        return instance.get(`files/generate-act/${actId}/`, {responseType: 'blob'})
    },
    signedActFileDoc: (actId) => {
        return instance.put(`files/generate-act/${actId}/`, actId)
    },
    downloadActExcelFileDoc: (actId) => {
        return instance.get(`files/generate-act-excel/${actId}/`, {responseType: 'blob'})
    },
    downloadViolationFile: (fileId) => {
        return instance.get(`files/get-violation-files/${fileId}/`, {responseType: 'blob'})
    },
    downloadActScanFile: (fileId) => {
        return instance.get(`files/get-act-files/${fileId}/`, {responseType: 'blob'})
    },
    createNormativeChapter: (name, normativeDocument, normativeChapter) => {
        return instance.post('master-of-acts/normative-chapters/', {
            name,
            normative_document: normativeDocument,
            normative_chapter: normativeChapter
        })
    },
    createNormativeArticles: (number, shortText, fullText, normativeDocument, normativeChapter) => {
        return instance.post('master-of-acts/normative-articles/', {
            number,
            short_text: shortText,
            full_text: fullText,
            normative_document: normativeDocument,
            normative_chapter: normativeChapter
        })
    },

    getReferenceDescription: handbook => instance.get(`master-of-acts/reference-descriptions/?handbook=${handbook}`),

    createReferenceDescription: (
        description,
        handbook,
        normativeDocument
    ) => instance.post(`master-of-acts/reference-descriptions/`, {
        description,
        handbook,
        normative_document: normativeDocument
    }),

    patchReferenceDescription: (id, data) => instance.patch(`master-of-acts/reference-descriptions/${id}/`, data),

    deleteReferenceDescription: id => instance.delete(`master-of-acts/reference-descriptions/${id}/`),

    getNormativeDocument: id => instance.get(`master-of-acts/normative-documents/${id}/`),

    getNormativeDocuments: folder => instance.get(`master-of-acts/normative-documents/?folder=${folder}`),

    createNormativeDocument: (name,
                              filename,
                              folder) => instance.post(`master-of-acts/normative-documents/`, {
        name,
        filename,
        folder
    }),

    patchNormativeDocument: (id, data) => instance.patch(`master-of-acts/normative-documents/${id}/`, data),

    deleteNormativeDocument: id => instance.delete(`master-of-acts/normative-documents/${id}/`),

    getNormativeChapter: id => instance.get(`master-of-acts/normative-chapters/${id}/`),
    
    uploadChart: (chart, creator) => {
        const formData = new FormData()
        formData.append("file", chart, `chart_creator_${ creator }_${ (new Date()).getTime() }.png`)
        formData.append('creator', creator)
        return instance.post(`master-of-acts/act-chart/`, formData)
    },

    uploadSignature: (signature, creator) => {
        const formData = new FormData()
        formData.append("file", signature, `sign_act_creator_${ creator }_${ (new Date()).getTime() }.png`)
        formData.append('creator', creator)
        return instance.post(`master-of-acts/act-signature/`, formData)
    },

    getSignature: (fileId) => {
        return instance.get(`master-of-acts/act-signature/${fileId}/`, {responseType: 'blob'})
    },

    deleteSignature: (fileId) => {
        return instance.delete(`master-of-acts/act-signature/${fileId}/`)
    },

    getActQr: (hashAct) => {
        return instance.get(`master-of-acts/qrcode/${hashAct}/`)
    },

    getViolationQR: (hashViolation) => {
        return instance.get(`master-of-acts/qr_violation/${hashViolation}/`)
    },

    getSupervisorProject: (contract) => {
        return instance.get(`master-of-acts/assign/${contract}/`)
    },
}

export const ActStatusesAPI = {
    getActsStatisticByStatus: (status) => instance.get(`/master-of-acts/acts/count_acts/?status=${status}`),

    getProjects: () => instance.get(`/master-of-acts/projects/`),

    // getProjectStatistic: (projectID) => instance.get(`/master-of-acts/acts/?environment_state__project=${projectID}&fields=id,status`)
}

export const UserAPI = {
    getUsers: (isMobile) => instance.get(`/user/get-user/?is_mobile=${isMobile}`),
    createUser: ({
                     username,
                     password,
                     email,
                     mobile,
                     mobile_status,
                     role,
                     mid_name,
                     appointment,
                     appointment_to_whom,
                     appointment_by_whom,
                     appointment_whom,
                     phone_number,
                     organization,
                     full_name_to_whom,
                     full_name_by_whom,
                     full_name_whom,
                     full_name,
                     first_name,
                     last_name,
                     is_activated
                 }) =>
        instance.post('/user/create/', {
            username,
            password,
            email,
            mobile,
            mobile_status,
            role,
            mid_name,
            appointment,
            appointment_to_whom,
            appointment_by_whom,
            appointment_whom,
            phone_number,
            organization,
            full_name_to_whom,
            full_name_by_whom,
            full_name_whom,
            full_name,
            first_name,
            last_name,
            is_activated
        }),
    patchUser: (id, data) => instance.patch(`/user/update-profile/${id}/`, data)
}

export const ProfileAPI = {
    getProfile: () => instance.get('user/me/'),
    updateProfile: (values) => instance.patch(`/user/update-self-profile/${values.id}/`, values),
    updatePassword: (userID, values) => instance.put(`/user/change-password/${userID}/`, values)
}

export const NormativeDocumentsAPI = {
    getDocumentFolders: () => instance.get(`/master-of-acts/document-folders/`),
    createDocumentFolder: (values) => instance.post(`/master-of-acts/document-folders/`, values),
    deleteDocumentFolder: (folderID) => instance.delete(`/master-of-acts/document-folders/${folderID}/`),
    updateDocumentFolder: (folderID, values) => instance.patch(`/master-of-acts/document-folders/${folderID}/`, values),

    getNormativeDocuments: () => instance.get(`/master-of-acts/normative-documents/`),
    createNormativeDocument: (values) => instance.post(`/master-of-acts/normative-documents/`, values),
    updateNormativeDocument: (documentID, values) => {
        return instance.patch(`/master-of-acts/normative-documents/${documentID}/`, values)
    },
    deleteNormativeDocument: (documentID) => {
        return instance.delete(`/master-of-acts/normative-documents/${documentID}/`)
    },
    downloadNormativeDocument: (documentID) => {
        return instance.get(`/files/get-normative-document/${documentID}/`, {responseType: 'blob'})
    },

    getNormativeChapters: (documentID) => {
        return instance.get(`/master-of-acts/normative-chapters/?normative_document=${documentID}`)
    },
    createNormativeChapter: (values) => {
        return instance.post(`/master-of-acts/normative-chapters/`, values)
    },
    updateNormativeChapter: (chapterID, values) => {
        return instance.patch(`/master-of-acts/normative-chapters/${chapterID}/`, values)
    },
    deleteNormativeChapter: (chapterID) => {
        return instance.delete(`/master-of-acts/normative-chapters/${chapterID}/`)
    },

    createNormativeArticle: (values) => {
        return instance.post(`/master-of-acts/normative-articles/`, values)
    },
    getNormativeArticles: (documentID) => {
        return instance.get(`/master-of-acts/normative-articles/?no_pagination&normative_document=${documentID}`)
    },
    updateNormativeArticle: (articleID, values) => {
        return instance.patch(`/master-of-acts/normative-articles/${articleID}/`, values)
    },

    uploadExcelNormativeDocument: (file, folderID) => instance.put(`/files/upload-excel-document/${folderID}/${file.name}/`, file),
    
    uploadCheckLIstInfo: (file) => {
        return instance.put(`/files/upload-excel-document-not-normative/null/${file.name}/`, file)
    },

    getExcelCheckListArticles: (id) => instance.get(`/master-of-acts/excel-articles/?excel_document=${id}`),

    getExcelCheckListChapters: (id) => instance.get(`/master-of-acts/excel-chapters/?excel_document=${id}`),


}

export const ProjectsEditAPI = {
    getCompanies: () => instance.get('/master-of-acts/companies/'),
    createCompany: (values) => instance.post('/master-of-acts/companies/', values),
    updateCompany: (values) => instance.patch(`/master-of-acts/companies/${values.id}/`, values),
    deleteCompany: (companyID) => instance.delete(`/master-of-acts/companies/${companyID}/`),

    getContracts: () => instance.get('/master-of-acts/contracts/'),
    createContract: (values) => instance.post('/master-of-acts/contracts/', values),
    updateContract: (values) => instance.patch(`/master-of-acts/contracts/${values.id}/`, values),
    deleteContract: (contractID) => instance.delete(`/master-of-acts/contracts/${contractID}/`),

    getProjects: () => instance.get('/master-of-acts/projects/'),
    createProject: (values) => instance.post('/master-of-acts/projects/', values),
    updateProject: (values) => instance.patch(`/master-of-acts/projects/${values.id}/`, values),
    deleteProject: (projectID) => instance.delete(`/master-of-acts/projects/${projectID}/`),
    copyProject: (id) => instance.post(`master-of-acts/project-copy/?project=${id}`, {id}),
    
}

export const HandbookEditAPI = {
    getReferenceDescriptions: (handbookID) => instance.get(`/master-of-acts/reference-descriptions/?handbook=${handbookID}`),
    createReferenceDescriptions: (values) => instance.post(`/master-of-acts/reference-descriptions/`, values),
    deleteReferenceDescriptions: (referenceDescriptionID) => instance.delete(`/master-of-acts/reference-descriptions/${referenceDescriptionID}/`,)
}

export const WordTemplateAPI = {
    getWordTemplate: (templateID) => instance.get(`/master-of-acts/word-templates/${templateID}/`),
    uploadWordTemplate: (templateID, values) => instance.put(`/master-of-acts/word-templates/${templateID}/`, values),
    downloadWordTemplate: (templateID) => instance.get(`/files/get-word-template/${templateID}/`, {responseType: 'blob'})
}

export const ExcelTemplateAPI = {
    getExcelTemplate: (templateID) => instance.get(`/master-of-acts/excel-templates/${templateID}/`),
    uploadExcelTemplate: (templateID, values) => instance.put(`/master-of-acts/excel-templates/${templateID}/`, values),
    downloadExcelTemplate: (templateID) => instance.get(`/files/get-excel-template/${templateID}/`, {responseType: 'blob'})
}

export const LibraryAPI = {
    getNormativeChaptersNotDeleted: (documentID) => instance.get(`/master-of-acts/normative-chapters/?normative_document=${documentID}&deleted=false`),
    getNormativeArticlesNotDeleted: (documentID) => instance.get(`/master-of-acts/normative-articles/?no_pagination&normative_document=${documentID}&deleted=false`)

}

export const MessageAPI = {
    postMessage: (message) => instance.post('/master-of-acts/send_message/', message)
}